import React, { useState, useMemo, useCallback, createContext, useRef, useEffect } from 'react'
import { useUser } from '@fs/zion-user'
import { fetchReservationsListCounts } from '../service/reservations'

export const CountsContext = createContext()

function useReservationCounts(cpUserId) {
  const [counts, setCounts] = useState(0)
  const isCurrent = useRef(true)

  const refetchCounts = useCallback(async () => {
    if (cpUserId) {
      const response = await fetchReservationsListCounts(cpUserId)
      isCurrent.current && setCounts({ ...response?.data })
      return { ...response?.data }
    }
    return ''
  }, [cpUserId])

  useEffect(() => {
    isCurrent.current = true

    return () => {
      isCurrent.current = false
    }
  }, [])
  return useMemo(() => ({ counts, refetchCounts }), [counts, refetchCounts])
}

export const CountsProvider = ({ children }) => {
  const user = useUser()
  const countsData = useReservationCounts(user?.cpUserId)
  return <CountsContext.Provider value={countsData}>{children}</CountsContext.Provider>
}
